import { lineAnimationType } from "./sprite-types";
export default [
    {
        name: '无',
        type: lineAnimationType.none,
    },
    {
        name: '水流',
        type: lineAnimationType.flow,
    },
    {
        name: '虚线',
        type: lineAnimationType.dottedLine,
    },
    {
        name: '圆点',
        type: lineAnimationType.dot,
    },
]